import { Text, View } from "@react-pdf/renderer";

import { ScoresData } from "~/providers/utils/types/patientPreviewTypes";

const TITLE_LOOKUP: Record<keyof ScoresData, string> = {
  gad7: "GAD-7",
  phq9: "PHQ-9",
  asrs: "ASRS",
};

export const ConsultationExportSummaryScores = ({
  scores,
}: {
  scores: ScoresData;
}) => {
  const entries = Object.entries(scores) as [
    keyof ScoresData,
    ScoresData[keyof ScoresData],
  ][];

  return (
    <View style={{ flexDirection: "row", gap: 12 }}>
      {entries.map(([key, score]) => (
        <View
          key={key}
          style={{
            alignItems: "center",
            backgroundColor: "#F0F4FE",
            borderColor: "#97B8F7",
            borderRadius: 6,
            borderWidth: 1,
            flexDirection: "column",
            gap: 12,
            justifyContent: "center",
            paddingHorizontal: 8,
            paddingVertical: 16,
            textAlign: "center",
            width: "33.33%",
          }}
        >
          <Text style={{ fontWeight: 600, fontSize: 18 }}>
            {TITLE_LOOKUP[key]}
          </Text>
          <Text
            style={{
              fontSize: 40,
              fontFamily: "Outfit",
              paddingHorizontal: 16,
              backgroundColor: "#DDE7FD",
              borderRadius: 6,
            }}
          >
            {score.score}
          </Text>
          <Text style={{ fontSize: 12, marginBottom: "auto" }}>
            {score.label}
          </Text>
        </View>
      ))}
    </View>
  );
};
